import request from "../axios/axios.js";
import { useEffect, useState } from "react";
import { Card, Spin, Button, Image, Divider, Form, Input, message, Modal, Switch } from "antd";
import { WindowsFilled, MailOutlined, LockOutlined, GooglePlusCircleFilled, GooglePlusOutlined } from "@ant-design/icons";
import Logo from "./AAPALogo.png";
import Applogo from './../LOGOAPP.png'
import { userAuthAction, userLoginEmailandPassword } from "../redux/action/authAction.js";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { BE_HOST } from "../config/config";
import { USER_TOKEN } from "../redux/types.js";
import { hashWithSalt } from "../utils/hash.js";
import logo from "../assets/marketPlacelogo.png";
import newLogo from "../assets/advant-logoTm.png";
import SmsoptModal from "../components/smsoptModal/SmsoptModal.jsx";


function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const userAuth = useSelector((state) => state.userAuth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get("redirect") || "/";
  const [acceptedTerms, setAcceptedTerms] = useState(true);
  const [smsModal,setSmsModal] = useState(false)

  const [searchParams] = useSearchParams();
  const [loginError, setLoginError] = useState('');
  useEffect(() => {
    const error = searchParams.get('error');
    if (error) {
      setLoginError(decodeURIComponent(error));
      alert(decodeURIComponent(error));
    }
  }, [searchParams]);
  // console.log("loginError", loginError)

  useEffect(() => {
    localStorage.clear();
  }, []);

  const getUserDetail = async (email) => {
    // Fetch user details after successful login
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${BE_HOST}/users/user-details?email=${email}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        localStorage.setItem("userDetails", JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleMicrosoftLogin = (value) => {
    setIsLoading(true);
    window.location = request.getBELoginUrl();
  };



  const handleSendOTP = async (email, phone) => {
    setIsLoading(true)
    const payload = {
      email: email || 'wetoy11785@cristout.com',
      phone: phone,
    };

    try {
      // console.log(" Sending request...");
      const response = await axios.post(`${BE_HOST}/auth/add-phone`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: "Bearer yourAccessToken"
          }
        }
      );
      console.log("Response:", response.data);
      navigate('/otp', {
        state: { email: email, mobile: phone,active:true }
      })
    } catch (error) {
      console.error(" Error:", error);
      message.error(error?.response?.data?.message)
      // navigate('/reset-password', {
      //   state: { email: email, mobile:mobile }
      // })
    } finally {
      setIsLoading(false)
      console.log(" Cleanup or loading state reset here");
      // Example: setLoading(false);
    }
  };

  const handleCredentialsLogin = async (values) => {
    if(!acceptedTerms){
      message.error("Please enable SMS Opt-In to continue");
      return;
    }    
    if(values?.password.length < 8){
      message.error('Invalid password');
      return;
    }
    setIsLoading(true);
    const payload = {
      email: values?.email,
      password: hashWithSalt(values?.password),
      url : BE_HOST
    };
    try {
      const response = await axios.post(`${BE_HOST}/auth/login`, payload, {
        headers: { "Content-Type": "application/json" }
      });

      const { user, tokens, message: successMessage } = response?.data;
      console.log(response, "response")
      const saveTokenAndAuth = () => {
        localStorage.setItem("token", tokens?.accessToken);
        localStorage.setItem("userInfo", JSON.stringify(response?.data));
        dispatch({
          type: USER_TOKEN,
          payload: {
            token: tokens?.accessToken,
            decodedToken: response?.data,
          },
        });
        message.success(successMessage);
      };

      if (user?.isPhoneVerified === true) {

        saveTokenAndAuth();
        navigate('/otp', {
          state: { email: values?.email, mobile: user?.phone, active:true,flag : false}
        });
        return;
      }
      else if ((user?.isPhoneVerified === false && user?.phone) || (user?.isPhoneVerified === null && user?.phone)) {
            saveTokenAndAuth();
            navigate('/otp', {
              state: { email: values?.email, mobile: user?.phone,active:true ,flag : true}
            });
            return;
      } else {
        saveTokenAndAuth(); // ✅ No modal case
        navigate('/MobileAuth', {
          state: { email: values?.email, mobile: response.data.phone, }
        });
      }

    } catch (error) {
      const step = error?.response?.data?.step;
      const errMsg = error?.response?.data?.message || "Login failed";
      const resetToken = error?.response?.data?.resetToken;
        console.log(error,"errorrr")

      if (step === "invalid_phone") {
        message.error(errMsg);
         dispatch({
          type: USER_TOKEN,
          payload: {
            decodedToken: error?.response?.data?.email,
          },
        });
        navigate('/MobileAuth', {
          state: {
            email: error?.response?.data?.email || values?.email,
            mobile: error?.response?.data?.phone || ""
          }
        });
      } else if (step === "reset_password") {
        message.info("Reset your password to continue.");
        navigate('/reset-password', {
          state: {
            email: values?.email,
            token: resetToken
          }
        });
      } else if (step === "login_with_otp") {
        message.error(errMsg);
        navigate('/otp', {
          state: {
            email: error?.response?.data?.email || values?.email,
            mobile: error?.response?.data?.phone || "",
            active:true
          }
        });
      } else {
        message.error(errMsg);
      }
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const loc = JSON.parse(localStorage.getItem("userInfo") || null);
    if (loc) {
      navigate(redirect);
    }
  }, [redirect, navigate, userAuth.userAuth]);


  const HandleforgotPassword = () => {
    navigate('/forgot')
  }


  return (
    <div className="min-h-screen bg-[#000833] from-gray-50 to-gray-100 flex flex-col items-center justify-start pt-8 p-4">
      {/* <Image
        style={{marginTop:"6px",marginBottom:"28px"}}
          src="./logo3.png"
          alt="AAPA Logo"
          preview={false}
          className=" rounded-md"
          width={180}
          height={180}
           shadow-md shadow-gray-300
          
        /> */}
        <div className="mb-6">
        <Image
          src={logo}
          alt="Logo"
          preview={false}
          className="mb-8"
          width={200}
          height={90}
        />
        </div>

      <div className="w-full max-w-[800px] flex flex-col items-center bg-[#000833] rounded-2xl
       border-[3px] border-white
       ">
        <Image
          style={{ marginTop: "28px", marginBottom: "28px" }}
          src={newLogo}
          alt="IPC Logo"
          preview={false}
          className="mb-8"
          width={300}
        // height={25}

        />

        <Card className="w-full max-w-[400px] shadow-lg rounded-lg overflow-hidden  bg-[#000833]">
          <h1 className="text-2xl  text-white text-center mb-6">
            Welcome to AdvantEdge
          </h1>

          {/* <Button
            block
            size="large"
            icon={<WindowsFilled />}
            onClick={handleMicrosoftLogin}
            className="h-12 flex items-center  mb-6"
          >
            Sign in with Microsoft AD
            Sign In
          </Button> */}

          {/* <Button
            block
            size="large"
            icon={<GooglePlusOutlined />}
            // onClick={handleMicrosoftLogin}
            className="h-12 flex items-center  mb-6"
          >
            Sign in with Google
          </Button> */}

          {/* <Divider className="text-gray-400">or</Divider> */}

          <Form
            form={form}
            onFinish={handleCredentialsLogin}
            layout="vertical"
            className="mt-4"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input
                prefix={<MailOutlined className="text-gray-400" />}
                placeholder="Email Address"
                size="large"
                className="h-12"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
                // {
                //   validator: (_, value) => {
                //     if (!value) return Promise.resolve();

                //     if (value.length < 8) {
                //       return Promise.reject("Password must be at least 8 characters");
                //     }

                //     if (!/[A-Z]/.test(value)) {
                //       return Promise.reject("Password must include an uppercase letter");
                //     }

                //     if (!/\d/.test(value)) {
                //       return Promise.reject("Password must include a number");
                //     }

                //     if (!/[^A-Za-z0-9]/.test(value)) {
                //       return Promise.reject("Password must include a special character");
                //     }

                //     return Promise.resolve();
                //   },
                // },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="text-gray-400" />}
                placeholder="Password"
                size="large"
                className="h-12"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type={acceptedTerms ? "primary" : "default"}
                htmlType="submit"
                block
                size="large"
                loading={isLoading}
                disabled={!acceptedTerms}
                className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
                style={
                !acceptedTerms
                   ? {
                       backgroundColor: "#888c88",
                       borderColor: "#888c88",
                       color: "#222",
                       boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
                     }
                   : undefined
               }
              >
                Sign in with Email
              </Button>
            </Form.Item>
          </Form>
           

          <div onClick={HandleforgotPassword}>
            <p className="text-white text-[15px] font-bold cursor-pointer hover:text-sky-400 transition-colors duration-200">Forgot Password</p>
          </div>
          <div className="flex gap-2 mt-2 justify-end items-start">
           
           <a
            //  href="/terms-and-conditions"
            onClick={()=>setSmsModal(true)}
             target="_blank"
             rel="noopener noreferrer"
             className="text-white underline hover:text-sky-400 text-[15px] font-semibold"
           >
             SMS Opt In
           </a>
           <Switch
             checked={acceptedTerms}
             onChange={(checked) => {
              if(!checked){
                message.error("Please enable SMS Opt-In to continue");
                setAcceptedTerms(checked)
              }else{
                setAcceptedTerms(checked)
              }
            }}
             size="medium"
             style={{
               backgroundColor: acceptedTerms ? "#0092ba" : "#d1d5db",
             }}
           />
         </div>
        </Card>

        <div className="mt-8 text-center text-white text-sm mb-3">
          <p>Powered by AdvantEdge Analytics</p>
          <p className="mt-2">
            {/* © {new Date().getFullYear()} Association of Affiliated Pharmacies
            and Apothecaries. All rights reserved. */}
            © AdvantEdge Holding LLC. (2025). All Rights Reserved
          </p>
        </div>
        <div className="mb-7  flex justify-center items-start px-2 text-white gap-2">
          <a
              href="https://myrxadvantedge.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline hover:text-blue-600 font-semibold"
            >
              Privacy Policy
            </a>
            | 
           <a
              href="https://myrxadvantedge.com/terms-of-service/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline hover:text-blue-600 font-semibold">
              Terms & Conditions
            </a>
              | 
              <a
                href="https://myrxadvantedge.com/communications-consent-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:underline hover:text-blue-600 font-semibold"
              >
                Communications Consent Policy
              </a>
        </div>
      </div>

      <style>
        {`
          .ant-message .ant-message-notice {
            padding: 16px 24px;
          }

          .ant-message .ant-message-notice-content {
            font-size: 24px;
            min-height: 50px;
            display: flex;
            align-items: center;
          }
        `}
      </style>
      <SmsoptModal
        hide={() => setSmsModal(false)}
        visible={smsModal}
      />
    </div>
  );
}

export default Login;
